const translations = {
  "en": {
    "Ed is listening. Please share your thoughts...": "Ed is listening. Please share your thoughts...",
    "Help Ed improve. Why are you leaving?": "Help Ed improve. Why are you leaving?",
    "I found a better alternative": "I found a better alternative",
    "I'm not using it enough": "I'm not using it enough",
    "Just testing, not ready to pay": "Just testing, not ready to pay",
    "Missing features I need": "Missing features I need",
    "Other": "Other",
    "submit": "submit",
    "Technical issues / bugs": "Technical issues / bugs",
    "title": "title",
    "Too expensive": "Too expensive",
    "We’re sorry to see you go": "We’re sorry to see you go"
  },
  "zh-tw": {
    "Ed is listening. Please share your thoughts...": "Ed 正在聆聽。請分享你的想法...",
    "Help Ed improve. Why are you leaving?": "協助 Ed 改善。你為什麼要離開？",
    "I found a better alternative": "我找到一個更好的替代方案",
    "I'm not using it enough": "我沒有充分使用它",
    "Just testing, not ready to pay": "僅供測試，尚未準備付款",
    "Missing features I need": "缺少我需要的功能",
    "Other": "其他",
    "submit": "提交",
    "Technical issues / bugs": "技術問題 / 程式錯誤",
    "title": "標題",
    "Too expensive": "太貴了",
    "We’re sorry to see you go": "很遺憾看到你要離開"
  }
};

export default translations;
